
import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Introduction from './components/IntroductionFirebase';
import Catalogues from './components/Catalogues';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import PrivateNewsletterExport from './components/PrivateNewsletterExport';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
 

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <div className="App">
              <div className="super_container">
                <div className="header_wrapper">
                  <Header />
                  <div className="header_spacer" aria-hidden="true" />
                </div>
                <main style={{ paddingTop: '0px' }}>
                  <Hero />
                  <Introduction />
                  <Catalogues />
                  <FAQ />
                  <CTA />
                </main>
                <Footer />
              </div>
            </div>
          }
        />
        <Route path="/private" element={<PrivateNewsletterExport />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
